
export interface IVIPCertificateSubcontracting {
	active?: boolean;
	amount?: number;
	text?: string;
}

export function createCertificateSubcontracting(text: string = ""): IVIPCertificateSubcontracting {
	return {
		active: false,
		amount: 0,
		text,
	};
}

export function checkCertificateSubcontracting(data: IVIPCertificateSubcontracting) {
	if (data.active === undefined) {
		data.active = false;
	}
	if (data.amount === undefined) {
		data.amount = 0;
	}
	if (data.text === undefined) {
		data.text = "";
	}
}
